import React from 'react'
import { Theme } from '@mui/material/styles'
import { withStyles } from 'tss-react/mui'
import Dialog from '@mui/material/Dialog'
import MuiDialogContent from '@mui/material/DialogContent'
import { DialogTitle } from '../DialogTitle/DialogTitle'
import { SignUpTerms } from './SignUpTerms'

const DialogContent = withStyles(MuiDialogContent, (theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
    maxHeight: 600,
    maxWidth: 900,
  },
}))

export interface DialogProps {
  open: boolean
  handleClose: () => void
}

export const DialogComponent = (props: DialogProps) => {
  const { open, handleClose } = props
  //Dialog for terms & conditions
  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        Terms & Conditions
      </DialogTitle>
      <DialogContent dividers>
        <SignUpTerms />
      </DialogContent>
    </Dialog>
  )
}
